export enum SubscriptionPlan {
  FREE = "Free",
  PREMIUM = "Premium",
  DEEP = "Deep",
  TEAM = "Team",
  ENTERPRISE = "Enterprise",
}
